import { connect } from 'react-redux'

import component from 'components/Customers'

const mapActionCreators = {
}

const mapStateToProps = (state) => ({
  customers: state.customers
})

export default connect(mapStateToProps, mapActionCreators)(component)



// WEBPACK FOOTER //
// ./src/routes/Customers/containers/CustomersContainer.js